export const Permissions = {
  MANAGE_NODE_GROUPS: "manage node groups",
  MANAGE_USER_GROUPS: "manage user groups",
  MANAGE_NODES_CRITICAL_ACTION: "manage nodes critical action",
  MANAGE_NODES_NORMAL_ACTION: "manage nodes normal action",
  MANAGE_FW_AND_CERTIFICATE: "manage fw and certificate",
  MANAGE_PROVISION: "manage provision",
  FW_UPDATE: "fw update",
};

export const ErrorTypes = Object.freeze({
  REFRESH_TOKEN_EXPIRED: "Refresh Token Expired",
  REFRESH_TOKEN_SUCCESS: "Refresh token success",
  NOT_LOGGED_IN: "Not Login",
  CONCURRENT_ACTION_ERROR: "Function already enable.",
  HOSTINFO_SAMEACTION_ERROR: "Task is already working.",
});

export const PermissionColor = {
  MANAGE_NODE_GROUPS: "#8BC34A",
  MANAGE_USER_GROUPS: "#3E8F3F",
  MANAGE_NODES_CRITICAL_ACTION: "#25afa8",
  MANAGE_NODES_NORMAL_ACTION: "#007bb6",
  MANAGE_FW_AND_CERTIFICATE: "#33A6FF",
  MANAGE_PROVISION: "#8b85c9",
  FW_UPDATE: "#FDB813",
};

// NMC_ACTSTS_ERR_Enum — the unified action-status error codes the backend
// returns for node actions (0 = OK; every failure is negative). Use mapActstsErr
// to turn a code into a human string. As of 2026-08-13 the FW flow also reports
// these codes (err "0" on both download- and install-done), so live FW code uses
// mapActstsErr too; the legacy FWUpateSts map below is kept only for the dead
// ManageFW_copy / ManageFWUpdateList files.
export const ActstsErr = {
  "0": "OK",
  "-1": "Invalid parameter",
  "-2": "Timeout",
  "-3": "Unexpected error",
  "-4": "Resource lack",
  "-5": "Network fail",
  "-10": "Agent not alive",
  "-11": "Agent parameter fail",
  "-12": "Agent task full",
  "-20": "Manifest download fail",
  "-21": "Manifest format fail",
  "-22": "Manifest verify fail",
  "-23": "Flash init fail",
  "-24": "Update deny",
  "-25": "Download fail",
  "-26": "Digest fail",
  "-27": "Install fail",
};

export const mapActstsErr = (err) =>
  ActstsErr[String(err)] ?? `Unknown error (${err})`;

// DEPRECATED: legacy FW status map (success = 100/200). The backend switched FW
// to NMC_ACTSTS_ERR_Enum (success = 0), so use mapActstsErr for live code. Only
// the dead ManageFW_copy / ManageFWUpdateList still reference this.
export const FWUpateSts = {
  0: "",
  100: "Download success.",
  200: "Update success.",
  "-1": "Unexpected error.",
  "-2": "Manifest download fail.",
  "-3": "Manifest format invalid.",
  "-4": "Manifest signature verify fail.",
  "-5": "Flash initial fail.",
  "-6": "Binary download fail.",
  "-7": "Digest of binary verify fail.",
  "-8": "Update fail.",
  "-100": "Update timeout",
};

// User group permissions that grant the ability to operate nodes
// (vs. meta-management permissions like manage-user-groups / manage-node-groups).
// Used to filter "non-admin" user groups eligible for binding to a node group.
export const OPERATIONAL_PERMISSIONS = [
  "manage nodes normal action",
  "manage nodes critical action",
  "manage fw and certificate",
  "manage provision",
  "fw update",
];
